import React, { useState, useEffect } from 'react';

/**
 * Renders an image tolerant to failures: tries images in order.
 * Understands relative URLs served by the backend ("/static-macron/…") and
 * automatically prefixes them with REACT_APP_BACKEND_URL so they resolve
 * through the ingress. Falls back to a Sudeporte placeholder if every URL fails.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const resolveUrl = (src) => {
  if (!src) return '';
  // Absolute or protocol-relative — leave as-is
  if (/^(https?:)?\/\//i.test(src)) return src;
  // Data URLs, blob URLs, plain paths that already start with public /
  if (src.startsWith('data:') || src.startsWith('blob:')) return src;
  // Backend-served static resource (served under /api/ so the k8s ingress
  // routes it to the FastAPI backend rather than the React dev server)
  if (src.startsWith('/api/') || src.startsWith('/static-macron') || src.startsWith('/uploads')) {
    return `${BACKEND_URL}${src}`;
  }
  return src;
};

const FallbackImage = ({ images, alt, className, fallbackIcon = true }) => {
  const list = Array.isArray(images) ? images.filter(Boolean).map(resolveUrl) : [];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [allFailed, setAllFailed] = useState(false);
  const [imageKey, setImageKey] = useState(0);

  useEffect(() => {
    setCurrentIndex(0);
    setAllFailed(false);
    setImageKey((prev) => prev + 1);
  }, [images]);

  const handleError = () => {
    if (currentIndex < list.length - 1) {
      setCurrentIndex((prev) => prev + 1);
      setImageKey((prev) => prev + 1);
    } else {
      setAllFailed(true);
    }
  };

  if (list.length === 0 || allFailed) {
    if (fallbackIcon) {
      return (
        <div className={`flex items-center justify-center bg-neutral-100 ${className}`}>
          <img
            src="/sudeporte-logo.png"
            alt="Sudeporte"
            className="w-32 opacity-40"
          />
        </div>
      );
    }
    return null;
  }

  return (
    <img
      key={imageKey}
      src={list[currentIndex]}
      alt={alt}
      className={className}
      onError={handleError}
    />
  );
};

export default FallbackImage;
